import React, { useState } from "react";
import { login } from "../api";
import { IcoAlert, IcoLock } from "./Icons";

export default function ConfirmPasswordDialog({ username, message, warning, onConfirm, onCancel }) {
  const [user, setUser] = useState(username || "");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    if (!user || !password || loading) return;

    setLoading(true);
    setError("");
    try {
      const res = await login(user, password);
      if (res.status === "success") {
        onConfirm();
      } else {
        setError("Sai mật khẩu, vui lòng thử lại");
      }
    } catch {
      setError("Không kết nối được tới máy chủ");
    }
    setLoading(false);
  };

  return (
    <div className="modal" role="alertdialog" aria-modal="true" aria-label="Xác nhận xóa thư mục">
      <div className="modal-card">
        <div className="modal-head">
          <span className="modal-ico danger"><IcoLock size={20} /></span>
          <div>
            <h3>Xác nhận xóa thư mục</h3>
          </div>
        </div>

        <form onSubmit={submit}>
          <div className="modal-body">
            {warning && (
              <div className="callout warn">
                <IcoAlert size={16} />
                <span>{warning}</span>
              </div>
            )}
            <p className="modal-text">{message}</p>

            {!username && (
              <label className="field">
                <span>Mã số nhân viên</span>
                <input
                  type="text"
                  placeholder="Mã số nhân viên…"
                  value={user}
                  onChange={(e) => setUser(e.target.value)}
                  autoFocus
                />
              </label>
            )}
            <label className="field">
              <span>Mật khẩu</span>
              <input
                type="password"
                placeholder="Nhập lại mật khẩu để xác nhận…"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoFocus={!!username}
              />
            </label>

            {error && <div className="form-error">{error}</div>}
          </div>

          <div className="modal-foot">
            <button className="btn btn-quiet" type="button" onClick={onCancel} disabled={loading}>
              Hủy
            </button>
            <button className="btn btn-danger" type="submit" disabled={loading || !user || !password}>
              {loading ? "Đang kiểm tra…" : "Xác nhận xóa"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
